import { EuiButton, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { Props, Action } from "./interface";
import "./styles.css";

export const Menu = (props:Props) =>{

  let {actions, className} = props;

  const getActions = useMemo(() =>{
    return actions.map((a:Action)=>{
      return (
      <EuiFlexItem grow={false}>
        <EuiButton size={a.size} fill color={a.color} isDisabled={a.isDisabled}
          onClick={()=> a.handle()} className={a.className ? a.className : "menuButton"}>
          {a.text}
        </EuiButton>
      </EuiFlexItem>
      )
    })
  },[actions])

  return (
    <EuiFlexGroup gutterSize="s" alignItems="center" justifyContent="flexEnd" className={className}>
      {getActions}
    </EuiFlexGroup>
  )
}
Menu.propTypes = {
  actions: PropTypes.array,
  className: PropTypes.string
}

Menu.defaultProps = {
  actions: [],
  className:""
}